import './hero/hero.block.js';
import './split/split.block.js';
import './slogan/slogan.block.js';
import './portfolio/portfolio.block.js';
import './pages-grid/pages-grid.block.js';
import './contact/contact.block.js';
import './manifest/manifest.block.js';
import './blog-posts/blog-posts.block.js';
